import React, { useRef } from "react";
import styles from '../../styles/countryadmissionsday.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from "../CustomImage";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Accordion from 'react-bootstrap/Accordion';

interface Props {
    faqdata: any;
}

const StudiesFAQ: React.FC<Props> = ({ faqdata }) => {
    const sliderRef = useRef<Slider>(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 3,
        rows: 3,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    arrows: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 3,
                    dotsClass: styles.sliderDots,
                    dots: true,
                }
            }
        ]
    };
    return (
        <>
            <div className={styles.studyquas} style={{ backgroundColor: faqdata?.sectionBgColor || "#EFEFFA" }}>
                <div>
                    <Container>
                        <Row>
                            <div className={styles.heading}>
                                <h2>{faqdata?.sectionTitle}</h2>
                            </div>
                        </Row>
                    </Container>
                    <Container>
                        <Row>
                            <div className={styles.popularCourseslider}>
                                <Slider {...settings} className={styles.slider} ref={sliderRef}>
                                    <div>
                                        <Row>
                                            {
                                                faqdata?.questions?.length > 0 &&
                                                faqdata?.questions?.map((faqsdata: any) => {
                                                    return (
                                                        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
                                                            <Accordion defaultActiveKey="0">
                                                                <Accordion.Item className={styles.stuAccordion} eventKey="1" >
                                                                    <Accordion.Header className={styles.accoHead} >{faqsdata?.question}</Accordion.Header>
                                                                    <Accordion.Body className={styles.accorBody}>
                                                                        {faqsdata?.answer}
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>
                                                        </Col>
                                                    )
                                                })
                                            }
                                        </Row>
                                    </div>
                                </Slider>
                            </div>
                        </Row>
                    </Container>
                </div >
            </div >
        </>
    )
}
export default StudiesFAQ;